import { Constants } from "appConstants";
import { HeaderBackoffice } from "components";
import useBackofficeUserToken from "hooks/useBackofficeUserToken";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export default function BackofficeLayout() {
	const navigate = useNavigate();
	const user = useBackofficeUserToken();

	const verifyLogin = () => {
		if (!user) {
			navigate("/");
		}
	};

	useEffect(verifyLogin, []);

	return (
		<>
			<HeaderBackoffice tabs={Constants.tabs} />
			<div className="mt-[4.5rem] outlet">
				<Outlet />
			</div>
		</>
	);
}
